import { VERIFICATION } from "../../constants";

const initState = {
  userId: "",
  firstName: "",
  lastName: "",
  country: "",
  dateBirth: "",
  email: "",
  documentType: "",
  documentFiles: {
    front: null,
    back: null,
    selfie: null,
  },
  idNumber: "",
  initialized: false,
};

const isEmptyValue = (value) =>
  value === undefined ||
  value === null ||
  value === "";

const VerificationReducer = (
  state = initState,
  action,
) => {
  switch (action.type) {
    case VERIFICATION.INIT_VERIFICATION:
      return {
        ...state,

        userId: isEmptyValue(state.userId)
          ? action.payload.userId
          : state.userId,

        firstName: isEmptyValue(state.firstName)
          ? action.payload.firstName
          : state.firstName,

        lastName: isEmptyValue(state.lastName)
          ? action.payload.lastName
          : state.lastName,

        country: isEmptyValue(state.country)
          ? action.payload.country
          : state.country,

        dateBirth: isEmptyValue(state.dateBirth)
          ? action.payload.dateBirth
          : state.dateBirth,

        email: isEmptyValue(state.email)
          ? action.payload.email
          : state.email,

        initialized: true,
      };

    case VERIFICATION.SET_DATA:
      return {
        ...state,
        ...action.payload,
      };

    case VERIFICATION.SET_DOCUMENT_FILE:
      return {
        ...state,

        documentFiles: {
          ...state.documentFiles,
          [action.payload.field]:
            action.payload.file,
        },
      };

    case VERIFICATION.SET_DOCUMENT_TYPE:
      return {
        ...state,
        documentType: action.payload,
      };

    case VERIFICATION.RESET:
      return initState;

    default:
      return state;
  }
};

export default VerificationReducer;
